export default {
	"autoLineComp": {
		"autoRouting": "การกำหนดเส้นทางอัตโนมัติ",
		"autoRoutingStrategy": "การกำหนดกลยุทธ์เส้นทางอัตโนมัติ",
		"availableVehicleTypeInformation": "ข้อมูลประเภทยานพาหนะในระบบ",
		"departurePrice": "ค่ารถขนส่งเริ่มต้น",
		"mutilPosPerExtraCost": "ต้นทุนกิโลเมตรเริ่มต้น",
		"startPlan": "เริ่มวางแผน",
		"vehicleTypeTips": "จำนวนรุ่นต้องเป็นจำนวนเต็มที่มากกว่าหรือเท่ากับ 0",
		"departurePriceTips": "ค่าขนส่งเริ่มต้นต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ 0 และทศนิยมไม่เกิน 2 ตำแหน่ง",
		"mutilPosPerExtraCostTips": "ค่าธรรมเนียมการส่งสินค้าหลายจุดเริ่มต้นต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ 0 และทศนิยมไม่เกิน 2 ตำแหน่ง!",
		"carCount": "โปรดระบุจำนวนยานพาหนะ",
		"noLineTips": "โปรดวางแผนเส้นทางการขนส่ง",
		"diffSendAddressTips": "กรุณาเลือกที่อยู่จัดส่งเดียวกัน",
		"senderLngLatTips": "ที่อยู่ผู้รับในใบตราส่งสินค้าไม่มีข้อมูลละติจูดและลองจิจูด!",
		"receiverLngLat": "ที่อยู่จัดส่งในใบตราส่งสินค้าไม่มีข้อมูลละติจูดและลองจิจูด!",
		"confirmSendAddressTips": "ท่านต้องการเพิ่มใบตราส่งสินค้าที่มีสถานที่จัดส่งเดียวกันในรายการจัดส่งหรือไม่?"
	},
	"billingDetailComp": {
		"orderServiceType": "ค่าธรรมเนียมในการเรียกเก็บ",
		"billingtableRouteOption": "แก้ไขในรายการส่งของ",
		"billingtableTransportOption": "แก้ไขในใบตราส่งสินค้า",
		"shareMethod": "วิธีจัดสรรตามสัดส่วน",
		"adjustBillingCost": "จำนวนเงินที่เรียกเก็บเงิน",
		"billingDesDialog": "คำแนะนำเกี่ยวกับการเรียกเก็บเงิน",
		"contractInfo": "ข้อมูลสัญญา",
		"projectName": "รายการสินค้า",
		"offerInfo": "ข้อมูลใบเสนอราคา",
		"businessData": "ข้อมูลธุรกิจ",
		"busDt": "ชั่วโมงทำการ",
		"billingDt": "เวลาที่สามารถเรียกเก็บเงินได้",
		"billingFee": "ผลลัพธ์การเรียกเก็บเงิน",
		"exceptdealChange": "กรุณาไปที่การจัดการข้อยกเว้นเพื่อแก้ไข"
	},
	"carChoiceComp": {
		"historyVehiclePre": "รุ่นที่เลือก",
		"addNewVehiclePre": "เพิ่มรุ่น"
	},
	"costDialogComp": {
		"event": "เหตุการณ์",
		"detailData": "ข้อมูลอย่างละเอียด"
	},
	"deliveryExecution": {
		"askIndex": "คำขอ",
		"actIndex": "คำสั่งตามจริง",
		"transportArrivedTotal": "เสร็จสมบูรณ์",
		"late": "ล่าช้า",
		"arrived": "มาถึงแล้ว"
	},
	"mainHeader": {
		"deskTop": "เดสก์ท็อปของฉัน",
		"quit": "ออกจากระบบ",
		"changePwd": "เปลี่ยนรหัสผ่าน",
		"nowPwd": "รหัสผ่านปัจจุบัน",
		"newPwd": "รหัสผ่านใหม่",
		"confirmPwd": "ยืนยันรหัสผ่าน",
		"confirmChange": "ยืนยันการเปลี่ยนแปลง",
		"userInfo": "ข้อมูลผู้ใช้"
	},
	"mapTrack": {
		"downloadData": "ดาวน์โหลดข้อมูลการติดตาม"
	},
	"onwayTracks": {
		"onwaytracksData": "การติดตามข้อมูล",
		"onwaytracksLx": "ทิศทางการไหล"
	},
	"operationLogComp": {
		"noChange": "ไม่มีการแก้ไข"
	},
	"resourceSelector": {
		"searchCapacityTips": "ค้นหาและเลือกขีดความสามารถปัจจุบัน"
	},
	"switchComp": {
		"switchChange": "คลิ๊กเพื่อเปลี่ยน"
	},
	"trackTransitDialog": {
		"tracktransitdialogCreate": "ข้อมูลที่อยู่ผู้รับใหม่",
		"askArriveGoodsDt": "เวลาถึงจุดหมายที่ได้กำหนดไว้"
	},
	"transitDialog": {
		"estimateArriveStationDt": "เวลาถึงจุดหมายโดยประมาณ",
		"estimateLeaveStationDt": "เวลาออกเดินทางโดยประมาณ",
		"transitdialogInMark": "คำแนะนำเกี่ยวกับการขนส่งขาเข้า",
		"transitdialogOutMark": "คำแนะนำเกี่ยวกับการขนส่งขาออก"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/components/components/components.js